export { Avatar as default } from '@material-ui/core';
